class CareerCircleController {
  constructor(ResultsService) {
    this.ResultsService = ResultsService;
    this.popoverLeft = 0;
  }
  calculateMatch() {
    return this.ResultsService.calculateOverallMatch(this.item.id);
  }
  getWidth() {
    let match = this.calculateMatch();
    if (match < 25) {
      return 25;
    } else {
      return match;
    }
  }
  getPopoverLeft() {
    return this.popoverLeft;
  }
}

CareerCircleController.$inject = ['ResultsService'];

export default CareerCircleController;



// WEBPACK FOOTER //
// ./src/components/careerCircle/careerCircle.controller.js